import { Component, OnInit } from '@angular/core';

import { DialogComponent, DialogService } from '../../dialog';
export interface SVModel {
  title: string;
  item: any;
}
@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.css']
})
export class OrderViewComponent extends DialogComponent<SVModel, boolean>
  implements SVModel, OnInit {
  title: string;
  item: any;
  result: any = { result: false, RtnItem: {} };
  constructor(
    dialogService: DialogService,
  ) {
    super(dialogService);
  }

  ngOnInit() {
  }
  updateStatus(s: number, i) {
    this.result.result = true;
    this.result.RtnItem = { status: s, item: i };
    this.close();
  }
}
